<template>
  <bulk-add
    title="Добавить перерасчеты"
    :subtitle="selectedHouse.address"
    delete-all-message="Вы действительно хотите удалить все перерасчеты?"
    success-save-message="Перерасчеты созданы"
    create-button-text="Создать перерасчёты"
    :back-link="{ name: 'uc_b_recalculations'}"
    :show-check-print="true"
    :get-rows="getTempPayments"
    :on-create="createTempPayments"
    :on-update="updateTempPayments"
    :on-delete="deleteTempPayments"
    :on-delete-all="deleteAllTempPayments"
    :on-submit="savePayments"
    :empty-row="emptyRow"
    :parse-row-body="parsePayment"
    :format-row="formatPayment"
    :row-component="rowComponent"
    :mobile-breakpoint="1630"
  />
</template>

<script>
import BulkAdd              from "@/components/calculated-program/invoices/BulkAdd";
import RecalculationsAddRow from "@/components/calculated-program/recalculations/RecalculationsAddRow";
import dateFormat           from "date-fns/format";

export default {
  name:       "RecalculationsAdd",
  components: { BulkAdd },
  data() {
    const house = this.$store.getters['appUser/selectedHouse'];
    const apartmentTypes = this.$store.getters['appUser/apartmentTypesByHouse'](house);

    return {
      rowComponent: RecalculationsAddRow,

      emptyRow: {
        buildingId:         house.id,
        target:             'house',
        isList:             'true',
        accountNumbers:     [],
        accountNumbersFrom: '',
        accountNumbersTo:   '',
        comment:            '',
        apartmentType:      apartmentTypes.length ? apartmentTypes[0].id : null,
        tariffs:            [],
      },

      idCounter: 1,
    };
  },
  computed:   {
    selectedHouse() {
      return this.$store.getters['appUser/selectedHouse'];
    },
  },
  methods:    {
    deleteAllTempPayments( buildingId ) {
      return Promise.resolve();
    },
    getTempPayments( buildingId ) {
      return Promise.resolve({ data: [] });
    },
    createTempPayments( refund ) {
      return Promise.resolve({ data: { id: this.idCounter++, body: JSON.stringify(this.emptyRow) } });
    },
    updateTempPayments( refund ) {
      return Promise.resolve({ data: refund });
    },
    deleteTempPayments( buildingId, index ) {
      return Promise.resolve();
    },
    savePayments( buildingId, recalculations ) {
      const idIndex = {};
      const body = recalculations.map(( { body, id }, index ) => {
        idIndex[index] = { id, tariffs: {} };
        let selection = body.target === 'house'
          ? 'all'
          : body.isList === 'true'
            ? 'list'
            : 'range';

        const tariffs = [];

        body.tariffs.forEach(( { data, id }, i ) => {
          idIndex[index].tariffs[i] = id;
          tariffs.push({
            id:     data.id,
            reason: data.reason || '',
            date:   data.date && dateFormat(data.date, 'MM.yyyy'),
            value:  data.value,
            type:   data.type,
            force:  data.force,
          });
        });

        return {
          apartmentsType:      body.apartmentType,
          apartmentsSelection: selection,
          apartmentsList:      body.accountNumbers,
          apartmentsRangeFrom: body.accountNumbersFrom,
          apartmentsRangeTo:   body.accountNumbersTo,
          comment:             body.accountantComment,
          tariffs,
        };
      });
      return this.$http.post(`/houses/${this.selectedHouse.id}/recalculation`, body).catch(( e ) => {
        const { response: { data } } = e;
        if (!Array.isArray(data)) throw e;

        const errors = [];
        data.forEach(( item, index ) => {
          if (!item.tariffs) return;
          errors.push({
            errors: item.tariffs.errors.reduce(( dict, errors, i ) => {
              dict[idIndex[index].tariffs[i]] = errors;
              return dict;
            }, {}),
            id:     idIndex[index].id,
          });
        });
        throw { response: { data: errors } };
      });
    },

    parsePayment( payment ) {
      return payment;
    },

    formatPayment( payment ) {
      return payment;
    },
  },
  watch:      {
    selectedHouse( house ) {
      this.emptyRow.buildingId = house.id;
      this.emptyRow.apartmentType = this.$store.getters['appUser/apartmentTypesByHouse'](house)[0].id;
    },
  },
};
</script>

<style lang="scss" module>

</style>
